import { QueuesDetailsPage } from 'components/settings/queues/components/queuesDetailsPage';

export const SettingsQueuesCreateView = (): JSX.Element => (
  <QueuesDetailsPage mode="create" />
);
